import timeFromNow from "../../services/timeFromNow";
import {
  PROJECT_REQUEST,
  PROJECT_FAIL,
  PROJECT_SUCCESS,
  PROJECT_CREDIT_OPTIONS_STATE_UPDATE,
  CURRENT_BLOCK_UPDATE,
  PROJECT_OPTION_SUCCESS,
  PROJECT_CREDITS_UPDATE_SUCCESS,
  FONT_STYLE_UPDATE,
  SETTING_OPTION_STATE,
  PROJECT_FONTSTYLE_UPDATE_SUCCESS,
  PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS,
  PROJECT_LOGO_UPLOAD_SUCCESS,
  PROJECT_SETTINGS_UPDATE_SUCCESS,
  PROJECT_RENDER_REQUEST_SUCCESS,
  BLOCK_MOVE,
  RENDER_DELETE_SUCCESS,
  RENDER_DELETE_All_SUCCESS,
} from "../actions/types";

const initialState = {
  isLoading: false,
  error: null,
  credits: null,
  members: [],
  fontStyle: null,
  settings: null,
  currentBlock: { idx: 0, id: null },
  lastSavedTime: new Date(),
  lastSaved: null,
  logos: [],
  googleSpreadSheetId: null,
  googleSheetLink: null,
  isVideoGenerated: null,
  renders: [],
};
const projectReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROJECT_REQUEST:
      return { ...state, isLoading: true };
    case PROJECT_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };
    case PROJECT_SUCCESS:
      const {
        _id,
        credits: _credits,
        members,
        googleSheetLink: _googleSheetLink,
        fontStyle: _fontStyle,
        settings: _settings,
        currentBlock: _currentBlock,
        logos: _logos,
        googleSpreadSheetId: _googleSpreadSheetId,
        isVideoGenerated: _isVideoGenerated,
        renders,
        title,
        projectStatus
      } = action.payload;
      return {
        ...state,
        isLoading: false,
        _id,
        credits: _credits,
        members,
        fontStyle: _fontStyle,
        settings: _settings,
        currentBlock: _currentBlock,
        logos: _logos,
        googleSpreadSheetId: _googleSpreadSheetId,
        googleSheetLink: _googleSheetLink,
        isVideoGenerated: _isVideoGenerated,
        lastSavedTime: new Date(),
        renders,
        title,
        projectStatus,
      };

    case PROJECT_CREDIT_OPTIONS_STATE_UPDATE:
      const { creditsIdx, optionKey, optionValue } = action.payload;
      const credits = [...state?.credits];
      if (optionValue === "sidebyside") {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "on",
        };
        credits[creditsIdx + 1].options = {
          ...credits[creditsIdx + 1]?.options,
          ["side_by_side"]: "on",
        };

      } else if (credits[creditsIdx-1]?.options?.block_inset==="sidebyside") {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "on",
        };
      }
      else if(optionKey=="double_columns" && !optionValue){
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "off",
          ["text_alignment"]: "center",
        };
      }
      // for column and pragraph
      else if(optionKey=="bullets" && optionValue !== null){
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["columns"]: "1",
          ["column_width"]: "100",
        };
      }
     
      else if(credits.length -1 ===creditsIdx){
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "off",
        };
      }
      else {
        credits[creditsIdx].options = {
          ...credits[creditsIdx]?.options,
          [optionKey]: optionValue,
          ["side_by_side"]: "off",
        };
        credits[creditsIdx + 1].options = {
          ...credits[creditsIdx + 1]?.options,
          ["side_by_side"]: "off",
        };
      }
      return {
        ...state,
        credits,
      };

    case CURRENT_BLOCK_UPDATE:
      const { id, idx } = action.payload;
      let currentBlock = state.currentBlock;
      currentBlock = { ...currentBlock, id, idx };
      return {
        ...state,
        currentBlock,
      };

    case SETTING_OPTION_STATE:
      const { settingsKey, settingsvalue } = action.payload;
      let settings = state.settings;
      settings[settingsKey] = settingsvalue;
      return {
        ...state,
        settings,
      };

    case PROJECT_OPTION_SUCCESS:
      const { options, creditsId } = action.payload;
      const _creditsIdx = state.credits.findIndex(
        (credit) => credit._id == creditsId
      );
      if (_creditsIdx === -1) return state;
      state.credits[_creditsIdx].options = options;
      return {
        ...state,
        isLoading: false,
        lastSavedTime: new Date(),
      };

    case PROJECT_CREDITS_UPDATE_SUCCESS:
      return {
        ...state,
        credits: action.payload.credits,
        lastSavedTime: new Date(),
        isLoading: false,
      };
    case FONT_STYLE_UPDATE:
      const { key, property, value } = action.payload;
      return {
        ...state,
        fontStyle: {
          ...state.fontStyle,
          [key]: { ...state.fontStyle[key], [property]: value },
        },
      };

    case PROJECT_FONTSTYLE_UPDATE_SUCCESS:
      const { fontStyle: __fontStyle, fontStyleType, fontStyleBody } = action.payload;
      return {
        ...state,
        fontStyle: {
          ...state.fontStyle,
          [fontStyleType]: __fontStyle,
          fontStyleBody: fontStyleBody
        },
        lastSavedTime: new Date(),
        isLoading: false,
      };

    case PROJECT_CREDITS_ITEMS_UPDATE_SUCCESS:
      const { creditsId: _creditsId, items, dataSaved } = action.payload;
      const __creditsIdx = state.credits.findIndex(
        (credit) => credit._id === _creditsId
      );
      if (__creditsIdx === -1) return state;
      state.credits[__creditsIdx].items = items;
      return {
        ...state,
        credits: [...state.credits],
        lastSavedTime: dataSaved ? new Date() : state.lastSavedTime,
        isLoading: false,
      };
    case PROJECT_LOGO_UPLOAD_SUCCESS:
      const { logos } = action.payload;
      return { ...state, logos, isLoading: false };
    case PROJECT_SETTINGS_UPDATE_SUCCESS:
      const { settings: __settings } = action.payload;
      return { ...state, settings: { ...__settings }, isLoading: false };
    case PROJECT_RENDER_REQUEST_SUCCESS:
      const { renders: _renders } = action.payload;
      return { ...state, renders: [..._renders], isLoading: false };
    //drag and drop reducer
    case BLOCK_MOVE:
      const { sourceIdx, targetIdx } = action.payload;
      const updatedCredits = [...state.credits];
      const [removed] = updatedCredits.splice(sourceIdx, 1);
      updatedCredits.splice(targetIdx, 0, removed);
      return {
        ...state,
        credits: updatedCredits,
      };
    //drag and drop end

    case RENDER_DELETE_SUCCESS:
      const { renderId } = action.payload;
      return {
        ...state,
        renders: [
          ...state.renders.filter((project) => project._id !== renderId),
        ],
      };
    // delete all renders RENDER_DELETE_All_SUCCESS
    case RENDER_DELETE_All_SUCCESS:
      const { deleterenders } = action.payload;
      return {
        ...state,
        renders: deleterenders
      };
    default:
      return state;
  }
};

export default projectReducer;
